import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
export const CriteriaElement = ({
  iconName,
  criteriaLabel,
  criteriaValue,
  isValidCriteria = true,
}: {
  iconName: string;
  criteriaLabel: string;
  criteriaValue?: string;
  isValidCriteria?: boolean;
}) => {
  return (
    <div className="my-10 flex flex-row items-center rounded-12 border-1 px-30 py-15">
      <div className="flex items-center">
        <Icon
          className="font-bold"
          dataTestid="CriteriaElement-icon"
          name={iconName}
          isNotSquare
          width="2em"
        />
      </div>
      <div className="flex flex-1 flex-col px-15 md:flex-row">
        <span data-testid="criteriaLabel">{criteriaLabel} :</span>
        <span data-testid="criteriaValue" className="font-bold md:px-5">
          {criteriaValue}
        </span>
      </div>
      <div className="flex items-center">
        {isValidCriteria ? (
          <Icon
            className="text-green"
            dataTestid="CriteriaElement-icon-checked"
            isNotSquare
            name={ICONS.CHECK_FILLED}
            width="2em"
          />
        ) : (
          <Icon
            className="text-red"
            name={ICONS.WARNING}
            isNotSquare
            width="2em"
            dataTestid="CriteriaElement-icon-crossed"
          />
        )}
      </div>
    </div>
  );
};
